﻿<template>
    <!-- shown while loading (placeholder cards), then only when there's something left to add -->
    <section v-if="cartNotEmpty() && (!showAddons || Available_Add_Ons().length > 0)" class="ao" :class="{ 'is-nested': nested }">
        <div v-if="!showAddons" class="ao-loading" role="status" aria-live="polite">
            <p>
                <svg class="ts-spinner" viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="3" opacity="0.25" /><path d="M22 12a10 10 0 0 0-10-10" stroke="currentColor" stroke-width="3" stroke-linecap="round" /></svg>
                {{ nested ? 'Checking available add-ons…' : 'Loading add-ons for ' + Trip_Name() + '…' }}
            </p>
            <div class="ao-list" aria-hidden="true">
                <div v-for="n in 2" :key="n" class="ao-item ao-skeleton">
                    <span class="ao-skeleton-media"></span>
                    <span class="ao-skeleton-body"><span></span><span></span><span></span></span>
                </div>
            </div>
        </div>

        <div id="addon-section" v-else>
            <div class="ao-head">
                <h3 v-if="nested">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 5v14M5 12h14" /></svg>
                    Available add-ons
                </h3>
                <h3 v-else>Optional add-ons for {{Trip_Name()}}</h3>
                <p>{{Add_On_Message()}}</p>
            </div>

            <div class="ao-list">
                <article class="ao-item" v-for="product in Available_Add_Ons()" :key="product.tour_id" :id="'add_on_' + product.tour_id">
                    <img class="ao-image" :src="image(product)" :alt="imageAltText(product)">
                    <div class="ao-body">
                        <h4 class="ao-title">{{product.name}}</h4>
                        <div class="ao-desc" v-html="product.description_short"></div>
                        <select_passengers :price="price(product)" :tour_details="product" :passengers="get_Booking_Passengers()" :parent_tour_id="trip?.tour_id" :tour_id="product.tour_id" :departure_date="trip?.departure_date"></select_passengers>
                    </div>
                </article>
            </div>
        </div>
    </section>
</template>

<script lang="ts" src="./add-ons.ts"></script>